<template>
  <div class="activity-manage">
    <!-- 操作欄 -->
    <div class="action-bar">
      <el-button type="primary" size="small" icon="el-icon-plus" @click="openDialog()">新增活動</el-button>
      <el-button type="success" size="small" icon="el-icon-plus" @click="goCreatePage">新增活動頁</el-button>
    </div>

    <!-- 活動列表 -->
    <el-table v-loading="loading" :data="tableData" border stripe style="width: 100%" size="small">
      <el-table-column prop="titleAc" label="活動標題" min-width="180" show-overflow-tooltip></el-table-column>
      <el-table-column prop="brand" label="品牌" width="100" align="center">
        <template slot-scope="scope">
          <el-tag size="small" :type="brandTagType(scope.row.brand)">{{ scope.row.brand }}</el-tag>
        </template>
      </el-table-column>
      <el-table-column label="活動時間" min-width="320">
        <template slot-scope="scope">
          <template v-if="parseTimeSlots(scope.row.optionaTimeAc).length">
            <div v-for="(t, i) in parseTimeSlots(scope.row.optionaTimeAc)" :key="i" class="time-slot-item">
              <span class="time-text">{{ t.date }} {{ t.startTime }}-{{ t.endTime }}</span>
              <el-tag size="mini" type="info">名額: {{ t.quota }}</el-tag>
            </div>
          </template>
          <span v-else class="empty-text">暫無活動時間</span>
        </template>
      </el-table-column>
      <el-table-column label="操作" width="160" align="center">
        <template slot-scope="scope">
          <el-button type="text" size="small" icon="el-icon-edit" @click="openDialog(scope.row)">編輯</el-button>
          <el-button type="text" size="small" icon="el-icon-delete" class="danger-btn" @click="handleDelete(scope.row)">
            刪除
          </el-button>
        </template>
      </el-table-column>
    </el-table>

    <!-- 新增/編輯彈窗 -->
    <el-dialog
      :title="isEdit ? '編輯活動' : '新增活動'"
      :visible.sync="dialogVisible"
      width="820px"
      custom-class="activity-dialog"
      :close-on-click-modal="false"
      top="6vh"
    >
      <el-form ref="activityForm" :model="form" :rules="formRules" label-width="100px" size="small">
        <el-form-item label="活動標題" prop="titleAc">
          <el-input v-model="form.titleAc" placeholder="請輸入活動標題" maxlength="50"></el-input>
        </el-form-item>
        <el-form-item label="品牌" prop="brand">
          <el-select v-model="form.brand" placeholder="請選擇品牌" style="width: 100%">
            <el-option label="HONGQI" value="hongqi"></el-option>
            <el-option label="ZEEKR" value="zeekr"></el-option>
            <el-option label="ICAUR" value="icaur"></el-option>
          </el-select>
        </el-form-item>
        <el-form-item label="活動時間">
          <div class="time-slot-area" v-if="form.optionaTimeAc.length > 0">
            <div v-for="(item, index) in form.optionaTimeAc" :key="index" class="time-slot-row">
              <el-date-picker
                v-model="item.date"
                type="date"
                placeholder="選擇日期"
                value-format="yyyy-MM-dd"
                size="small"
                style="width: 150px"
              ></el-date-picker>
              <el-time-picker
                v-model="item.startTime"
                placeholder="開始"
                value-format="HH:mm"
                format="HH:mm"
                size="small"
                style="width: 110px"
              ></el-time-picker>
              <span class="time-sep">至</span>
              <el-time-picker
                v-model="item.endTime"
                placeholder="結束"
                value-format="HH:mm"
                format="HH:mm"
                size="small"
                style="width: 110px"
              ></el-time-picker>
              <el-input-number
                v-model="item.quota"
                :min="0"
                :max="9999"
                placeholder="名額"
                size="small"
                style="width: 120px"
                controls-position="right"
              ></el-input-number>
              <el-button
                type="danger"
                icon="el-icon-delete"
                size="mini"
                circle
                @click="removeTimeSlot(index)"
              ></el-button>
            </div>
          </div>
          <el-button type="primary" size="small" icon="el-icon-plus" plain @click="addTimeSlot">添加時間段</el-button>
        </el-form-item>
      </el-form>
      <div slot="footer">
        <el-button size="small" @click="dialogVisible = false">取 消</el-button>
        <el-button size="small" type="primary" :loading="submitting" @click="handleSubmit">確 定</el-button>
      </div>
    </el-dialog>
  </div>
</template>

<script>
import { activityListApi, activityAddApi, activityUpdateApi, activityDeleteApi } from '@/Api/requestApi'

export default {
  name: 'ActivityManage',
  props: {
    brand: {
      type: String,
      default: 'icaur',
    },
  },
  data() {
    return {
      loading: false,
      submitting: false,
      tableData: [],
      dialogVisible: false,
      isEdit: false,
      editId: null,
      form: {
        titleAc: '',
        brand: '',
        optionaTimeAc: [],
      },
      formRules: {
        titleAc: [{ required: true, message: '請輸入活動標題', trigger: 'blur' }],
        brand: [{ required: true, message: '請選擇品牌', trigger: 'change' }],
      },
    }
  },
  watch: {
    brand() {
      this.fetchData()
    },
  },
  mounted() {
    this.fetchData()
  },
  methods: {
    parseTimeSlots(val) {
      if (!val) return []
      if (Array.isArray(val)) return val
      if (typeof val === 'string') {
        try {
          const parsed = JSON.parse(val)
          return Array.isArray(parsed) ? parsed : []
        } catch (e) {
          return []
        }
      }
      return []
    },
    async fetchData() {
      this.loading = true
      try {
        const {
          data: { code, data },
        } = await activityListApi({ brand: this.brand })
        if (code === 200) {
          this.tableData = data || []
        }
      } catch (err) {
        console.error('獲取活動列表失敗:', err)
      } finally {
        this.loading = false
      }
    },
    openDialog(row) {
      this.isEdit = !!row
      if (row) {
        this.editId = row.id
        const timeSlots = this.parseTimeSlots(row.optionaTimeAc)
        this.form = {
          titleAc: row.titleAc || '',
          brand: row.brand || this.brand,
          optionaTimeAc: timeSlots.map((t) => ({
            date: t.date || '',
            startTime: t.startTime || '',
            endTime: t.endTime || '',
            quota: t.quota || 0,
          })),
        }
      } else {
        this.editId = null
        this.form = {
          titleAc: '',
          brand: this.brand,
          optionaTimeAc: [],
        }
      }
      this.dialogVisible = true
      this.$nextTick(() => {
        this.$refs.activityForm && this.$refs.activityForm.clearValidate()
      })
    },
    addTimeSlot() {
      this.form.optionaTimeAc.push({ date: '', startTime: '', endTime: '', quota: 0 })
    },
    removeTimeSlot(index) {
      this.form.optionaTimeAc.splice(index, 1)
    },
    validateTimeSlots() {
      const slots = this.form.optionaTimeAc
      if (!slots || slots.length === 0) return true
      for (let i = 0; i < slots.length; i++) {
        const s = slots[i]
        if (!s.date && !s.startTime && !s.endTime) continue // 完全空行跳過
        if (!s.date || !s.startTime || !s.endTime || (s.quota && s.quota <= 0)) {
          this.$message({ message: `請完整填寫第 ${i + 1} 個時間段`, type: 'warning' })
          return false
        }
        if (s.startTime >= s.endTime) {
          this.$message({ message: `第 ${i + 1} 個時間段：結束時間需大於開始時間`, type: 'warning' })
          return false
        }
      }
      return true
    },
    async handleSubmit() {
      this.$refs.activityForm.validate(async (valid) => {
        if (!valid) return
        if (!this.validateTimeSlots()) return
        this.submitting = true
        try {
          const payload = {
            titleAc: this.form.titleAc,
            brand: this.form.brand,
            optionaTimeAc: this.form.optionaTimeAc.filter((t) => t.date && t.startTime && t.endTime),
          }
          let res
          if (this.isEdit) {
            res = await activityUpdateApi({ id: this.editId, ...payload })
          } else {
            res = await activityAddApi(payload)
          }
          const { code, message } = res.data
          if (code === 200) {
            this.$message({ message: this.isEdit ? '修改成功' : '創建成功', type: 'success' })
            this.dialogVisible = false
            this.fetchData()
            this.$emit('activity-changed')
          } else {
            this.$message({ message: message || '操作失敗', type: 'error' })
          }
        } catch (err) {
          console.error('提交活動失敗:', err)
          this.$message({ message: '提交失敗', type: 'error' })
        } finally {
          this.submitting = false
        }
      })
    },
    handleDelete(row) {
      this.$confirm(`確定要刪除活動「${row.titleAc}」嗎？`, '提示', {
        confirmButtonText: '確定',
        cancelButtonText: '取消',
        type: 'warning',
      })
        .then(async () => {
          try {
            const {
              data: { code, message },
            } = await activityDeleteApi({ id: row.id })
            if (code === 200) {
              this.$message({ message: '刪除成功', type: 'success' })
              this.fetchData()
              this.$emit('activity-changed')
            } else {
              this.$message({ message: message || '刪除失敗', type: 'error' })
            }
          } catch (err) {
            console.error('刪除活動失敗:', err)
            this.$message({ message: '刪除失敗', type: 'error' })
          }
        })
        .catch(() => {})
    },
    brandTagType(brand) {
      const map = { hongqi: 'danger', zeekr: '', icaur: 'warning' }
      return map[brand] || 'info'
    },
    goCreatePage() {
      this.$router.push({ path: '/RTS/KLM/activity-page', query: { brand: this.brand } })
    },
  },
}
</script>

<style lang="scss" scoped>
.activity-manage {
  .action-bar {
    margin-bottom: 16px;
  }

  .empty-text {
    color: #c0c4cc;
    font-size: 12px;
  }

  .time-slot-item {
    display: flex;
    align-items: center;
    gap: 8px;
    margin-bottom: 4px;
    &:last-child {
      margin-bottom: 0;
    }

    .time-text {
      font-size: 12px;
      color: #555;
    }
  }

  .danger-btn {
    color: #f56c6c;
  }

  .time-slot-area {
    background: #f5f7fa;
    border: 1px solid #e4e7ed;
    border-radius: 6px;
    padding: 12px;
    margin-bottom: 10px;
    max-height: 300px;
    overflow-y: auto;
  }

  .time-slot-row {
    display: flex;
    align-items: center;
    flex-wrap: nowrap;
    gap: 6px;
    margin-bottom: 8px;
    padding: 6px 8px;
    background: #fff;
    border-radius: 4px;
    border: 1px solid #ebeef5;

    &:last-child {
      margin-bottom: 0;
    }

    .time-sep {
      font-size: 12px;
      color: #666;
      flex-shrink: 0;
    }
  }
}

/* 手機端適配 */
@media (max-width: 768px) {
  .action-bar {
    ::v-deep .el-button {
      width: 100%;
    }
  }

  ::v-deep .activity-dialog {
    width: 94% !important;
    margin-top: 5vh !important;

    /* 表單欄目標題佔一行、輸入框佔一行 */
    .el-form-item__label {
      float: none;
      display: block;
      width: 100% !important;
      text-align: left;
      padding: 0 0 6px;
      line-height: 1.4;
    }

    .el-form-item__content {
      margin-left: 0 !important;
    }
  }

  .time-slot-area {
    padding: 8px;
    max-height: 240px;
  }

  .time-slot-row {
    flex-wrap: wrap !important;
    gap: 8px;

    ::v-deep .el-date-editor,
    ::v-deep .el-input-number {
      width: calc(50% - 4px) !important;
    }

    .time-sep {
      display: none;
    }
  }
}
</style>
